import { IFirmsAndInstrumentsMessageResponse, IInstrument } from '../../interfaces';

export function flattenInstruments({ instrumentsMap }: IFirmsAndInstrumentsMessageResponse): Array<IInstrument> {
    return Object.values(instrumentsMap).flat();
}
